<div class="w-100 h-100" fxLayout="column" fxLayoutAlign="center center">
    <div fxLayout="row" class="header pl-20 pr-20 main-bc w-100" ngClass.mobile="pr-16" fxLayoutAlign="space-between center"
         fxFlexAlign="start">
        <ui-kit-svg fxHide.mobile class="header-logo" name="header-logo"/>
        <ui-kit-svg fxHide fxShow.mobile class="i-40" name="header-logo-mobile"/>
        <ui-kit-language-toggle class="ml-32"/>
    </div>
    <div fxLayout="column" fxLayoutAlign="center center" fxLayoutAlign.mobile="start center"
         class="w-100 h-100" [class.overlap-back-logos]="notTransparentBackground">
        <div
            fxLayout="column" fxLayoutAlign="center center"
            class="w-514 pl-56 pr-56 pt-48 pb-36 radius-16"
            [ngClass.mobile]="{'main-shadow': false, 'w-514': false, 'pl-56': false, 'pr-56': false, 'pt-48': false, 'pb-36': false, 'w-100': true, 'pl-24': true, 'pr-24': true, 'pt-64': true, 'pb-48': true}"
            [class.main-shadow]="notTransparentBackground">
            <ui-kit-svg class="error-logo" [name]="errorIcon"/>
            <div class="h3-semi-bold mt-32 text-center pre-line">{{ errorTitle | translate }}</div>
            <div class="t2 mt-16 pre-line text-center">{{ errorSubtitle | translate }}</div>
            @if (showRequestId && requestId) {
                <ui-kit-error-panel/>
                @if (showRequestId && requestId) {
                    <div class="t4 mt-16 c-primary-gray-600 pre-line text-center">
                        {{ errorCodeTitle | translate: {code: requestId} }}
                        <ui-kit-svg matRipple
                                    class="i-16 circle pointer ml-8"
                                    name="ic_copy"
                                    ngxClipboard
                                    [matRippleCentered]="true"
                                    [matRippleUnbounded]="true"
                                    [cbContent]="requestId"/>
                    </div>
                }
            }
            <div class="mt-40">
                <ui-kit-button ngClass.mobile="w-100"
                               type="secondary"
                               [label]="buttonTitle | translate"
                               (clickListener)="retry()"/>
            </div>
        </div>
    </div>

    <ui-kit-svg class="logo-left" name="bc-logo"/>
    <ui-kit-svg class="logo-right" name="bc-logo"/>
</div>
